module.exports = __webpack_public_path__ + "img/appltCourse-img33.bee80b34.png";